import React from 'react';

const Skills = () => {
  const skillCategories = [
    {
      title: "Programming Languages",
      icon: "fa-code",
      color: "from-blue-500 to-blue-600",
      skills: [
        { name: "Python", level: 90 },
        { name: "R", level: 85 },
        { name: "SQL", level: 80 },
        { name: "C#", level: 75 }
      ]
    },
    {
      title: "Machine Learning & AI",
      icon: "fa-robot",
      color: "from-purple-500 to-purple-600",
      skills: [
        { name: "Machine Learning", level: 88 },
        { name: "Deep Learning", level: 85 },
        { name: "TensorFlow", level: 82 },
        { name: "PyTorch", level: 80 },
        { name: "Keras", level: 83 }
      ]
    },
    {
      title: "Data Analysis & Visualization",
      icon: "fa-chart-line",
      color: "from-green-500 to-green-600",
      skills: [
        { name: "Pandas", level: 90 },
        { name: "NumPy", level: 88 },
        { name: "Matplotlib", level: 85 },
        { name: "Scikit-learn", level: 87 },
        { name: "Statistical Analysis", level: 85 }
      ]
    },
    {
      title: "Development & Databases",
      icon: "fa-database",
      color: "from-red-500 to-red-600",
      skills: [
        { name: "ASP.NET Core", level: 78 },
        { name: "SQL Server", level: 82 },
        { name: "MySQL", level: 80 },
        { name: "PostgreSQL", level: 75 },
        { name: "Visual Studio", level: 85 }
      ]
    },
    {
      title: "Tools & Soft Skills",
      icon: "fa-tools",
      color: "from-yellow-500 to-yellow-600",
      skills: [
        { name: "Project Management", level: 82 },
        { name: "Teamwork", level: 90 },
        { name: "Leadership", level: 85 },
        { name: "Microsoft Office", level: 88 }
      ]
    }
  ];

  return (
    <section id="skills" className="section-padding bg-white/70 backdrop-blur-md shadow-lg">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Skills & Expertise</h2>
          <div className="w-20 h-1 bg-primary-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Technical proficiencies and soft skills developed through academic study and practical experience
          </p>
        </div>

        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {skillCategories.map((category, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 card-hover border border-gray-100"
            >
              <div className="text-center mb-6">
                <div className={`w-16 h-16 bg-gradient-to-r ${category.color} rounded-full flex items-center justify-center mb-4 mx-auto`}>
                  <i className={`fas ${category.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{category.title}</h3>
              </div>

              <div className="space-y-4">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex}>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-700 font-medium">{skill.name}</span>
                      <span className="text-sm text-gray-500">{skill.level}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className={`bg-gradient-to-r ${category.color} h-2 rounded-full transition-all duration-1000 ease-out`}
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
